<script>
  export let label = "";
  export let value = "";
</script>

<div class="survey_estimated_time">
  <span class="survey_estimated_time_icon" aria-hidden="true"></span>
  <p>{label}: {value}</p>
</div>

<style>
  .survey_estimated_time {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--pax-black);
  }

  .survey_estimated_time_icon {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    flex: 0 0 auto;
    background: var(--pax-orange);
    mask: url("/img/assistant/icons/clock.svg") center / contain no-repeat;
    -webkit-mask: url("/img/assistant/icons/clock.svg") center / contain no-repeat;
  }

  .survey_estimated_time p {
    margin: 0;
    color: var(--pax-black);
    font-size: 0.8rem !important;
    font-weight: 400;
    line-height: 1.2;
  }
</style>
